import React from 'react';
import { Switch } from '@material-ui/core';
import { InputGroup, Typography, Div } from '@icecreamsocial/components';
import { useScriptSettings } from '../../../../providers';
import { MultiToggle } from '../../../../../../../../../../presentational';

export const BehaviorCustomizer = () => {
	const { settings, updateBehavior } = useScriptSettings();

	const handleChange = (field) => (e) => {
		const { checked } = e.currentTarget;
		updateBehavior({ [field]: checked });
	};

	return (
		<form>
			{settings.behavior?.flavor !== 'embedded' && (
				<>
					<InputGroup display='flex' alignItems='center'>
						<Switch
							name={`openByDefault`}
							color='primary'
							defaultChecked={true}
							checked={settings.behavior?.openByDefault}
							onChange={handleChange('openByDefault')}
						/>{' '}
						<InputGroup.Label display='inline-block'>
							Open by default
						</InputGroup.Label>
					</InputGroup>
					<InputGroup display='flex' alignItems='center' marginBottom='md'>
						<Switch
							name={`forceOpen`}
							color='primary'
							value={settings.behavior?.forceOpen}
							checked={settings.behavior?.forceOpen}
							onChange={handleChange('forceOpen')}
						/>{' '}
						<InputGroup.Label display='inline-block'>
							Force open
						</InputGroup.Label>
					</InputGroup>
					<Typography.Span display='block' marginBottom='sm' typoWeight='500'>
						Launch delay
					</Typography.Span>
					<MultiToggle
						options={[
							{
								text: 'Show immediately',
								onClick: () => updateBehavior({ delay: undefined }),
							},
							{
								text: 'Show after X milliseconds',
								onClick: () => updateBehavior({ delay: 0 }),
							},
						]}
					/>
					{settings.behavior?.delay >= 0 && (
						<InputGroup marginBottom='md'>
							<InputGroup.Label typoWeight='500'>
								Delay (milliseconds)
							</InputGroup.Label>
							<Div
								display='flex'
								alignItems='center'
								elWidth='100%'
								style={{ gap: '16px' }}
							>
								<InputGroup.Fields>
									<InputGroup.Input
										name='delay'
										onChange={(e) => {
											const { value } = e.currentTarget;
											updateBehavior({ delay: value });
										}}
										defaultValue={0}
										value={settings.behavior?.delay}
										paddingLeft='md'
									/>
								</InputGroup.Fields>
								<InputGroup.Label>
									ms{' '}
									<Typography.Span as='small' typoSize='70%'>
										(1000 ms = 1 s)
									</Typography.Span>
								</InputGroup.Label>
							</Div>
						</InputGroup>
					)}
				</>
			)}
		</form>
	);
};
